<template>
<div class="chapter">
<div class="inner_page">
<div id="a02_tp">
<a id="page_3">
<p class="imagesm"><img alt="image" src="images/linr.jpg"/></p>
<p class="title1a"><b>TANKS <br/>IN HELL</b></p>
<p class="title2">A MARINE CORPS<br/>TANK COMPANY<br/>ON TARAWA</p>
<p class="imagesmm"><img alt="image" src="images/linr.jpg"/></p>
<p class="editor"><i>Oscar E. Gilbert &amp; Romain Cansiere</i></p>
<p class="published"><img alt="image" src="images/casemate1.jpg"/></p>
</a></div><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_tp.vue?91778914